import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Avatar from '../Avatar';
import { USER_OPTION_SIZE, USER_OPTION_SIZES } from './constants';
import { isEmail, parseUserText, resolveUserLines } from './helpers';

const UserOption = ({
    name,
    email,
    description,
    photo,
    size = USER_OPTION_SIZE.SM,
    tinted = true,
    className,
    ...rest
}) => {
    const safeSize = USER_OPTION_SIZES.has(size) ? size : USER_OPTION_SIZE.SM;
    const { title, subtitle } = resolveUserLines({ name, email, description });
    // Initials from an email would read as "M." — a legacy email-only reviewer gets the icon.
    const avatarName = title && !isEmail(title) ? title : null;

    return (
        <span className={classNames('ds-user-option', `ds-user-option--${safeSize}`, className)} {...rest}>
            <Avatar
                size={safeSize}
                variant="image"
                src={photo || null}
                name={avatarName}
                tinted={tinted && !photo}
                alt=""
                className="ds-user-option__avatar"
            />
            <span className="ds-user-option__text">
                <span className="ds-user-option__name">{title}</span>
                {subtitle && <span className="ds-user-option__email">{subtitle}</span>}
            </span>
        </span>
    );
};

UserOption.propTypes = {
    /** Display name; an email-only person shows the email here instead */
    name: PropTypes.string,
    /** Second line when no description is given; omitted when equal to the name */
    email: PropTypes.string,
    /** Second line (e.g. the role); wins over the email */
    description: PropTypes.string,
    /** Photo URL; falls back to colored initials */
    photo: PropTypes.string,
    /** Avatar size: xs (24) / sm (32, default) / md (40) */
    size: PropTypes.oneOf(Object.values(USER_OPTION_SIZE)),
    /** Brand-tinted initials (design default); false uses the per-person generated color */
    tinted: PropTypes.bool,
    /** Extra class on the root */
    className: PropTypes.string,
};

export { USER_OPTION_SIZE, USER_OPTION_SIZES, isEmail, parseUserText, resolveUserLines };
export default UserOption;
